module.exports = __webpack_public_path__ + "static/img/carousel_4_ur2nwj_ar_4_3_w_1200.4192a3c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/carousel/carousel_4_ur2nwj_ar_4_3_w_1200.jpg
// module id = Vupx
// module chunks = 0